import * as React from 'react';

// icons
import 'font-awesome/css/font-awesome.min.css';

// styling
import 'bootstrap/dist/css/bootstrap.min.css';

// toast
import 'react-toastify/dist/ReactToastify.css';

// flags 
import 'flag-icon-css/css/flag-icon.css';

// services
import {currentBaseUrl, currentUser, isUserLoggedIn, getStripeKey} from '../../common/services';

// components
import Loader from 'react-loader'
import NavBar from '../../components/CustomNav/CustomNav.Component';

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer} from 'react-toastify';

// reactstrap
import StripeCheckout from 'react-stripe-checkout';

// tabs
import {Breadcrumb, BreadcrumbItem, Button,Col, Row} from 'reactstrap';

class CheckoutPage extends React.Component {
    public state = {
      baseurl: currentBaseUrl(),
      destination: '',
      loaded: false,
      mounted: false,
      navigate: false,
      tologin: false,
      username: '',
    }

    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
    }

    public onLogout(arg) {
        console.log('Logout in Parent', arg);
        this.setState({tologin: true});
    }

    public openWidget(param, e) {
        console.log('widget: ' + param)
        this.setState({destination: currentBaseUrl() + param})
        this.setState({navigate: true})
    }

    public onChange(arg) {
        console.log('On change', arg);
    }

    public componentDidMount() {

        if(!isUserLoggedIn()){
            this.setState({ tologin: true });
          }
        else{
            this.setState({ username: currentUser()});
            // load data
            // getAllStudents(false, 1, text => this.handleStudentsLoaded(text));
        }

        this.setState({ mounted: true});
    }

    public onToken = (token) => {
        // TODO: Send the token information and any other
        // relevant information to your payment process
        // server, wait for the response, and update the UI
        // accordingly. How this is done is up to you. Using
        // XHR, fetch, or a GraphQL mutation is typical.
    };

    public render() {
        if (this.state.tologin === true) {
           return <Redirect to='/login'/>
        }
        if (this.state.navigate === true) {
            return <Redirect to={this.state.destination}/>
        }
        
        return (
            <div>

              <NavBar logoutParent={this.onLogout}/>
              <StripeCheckout
                amount={5}
                description="Basic Package"
                image="https://yourdomain.tld/images/logo.svg"
                locale="auto"
                name="mypl.life"
                stripeKey={getStripeKey()}
                token={this.onToken}
              />
               
            </div>      
        )
    }
}

export default CheckoutPage;


// WEBPACK FOOTER //
// ./src/pages/Subscription/checkoutPage.Component.tsx